import React, { useState } from 'react';
import MainModal from 'components/ModalMain';
import Button from 'components/Button';
import { useMutation } from "@apollo/client";
import { ADD_VOUCHER } from "graphql/service";
import { Container } from './styles';

const ModalGeneralFailed = ({
  buttonStyle,
  selectedBookingId,
  voucherPrice = 0
}) => {

  const [isOpen, setIsOpen] = useState(false);

  
  const [addVoucher, { loading: addVoucherLoading }] = useMutation(ADD_VOUCHER, {
  });

  const handleAddVoucher = (e) => {
    addVoucher({
      variables: {
        bookingId: selectedBookingId,
      }
    })
  };
  
  return (
    <MainModal
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      buttonStyle={buttonStyle}
      buttonLabel="Add Voucher"
      className="modal-success"
      additionalstyle={`
        max-width: 500px;
        .modal-content{
          height: 100%;
          .close {
            z-index: 200;
          }   
          .modal-body{
            height: 100%;
            padding: 24px;
          }
        }
        top: 179px;
      `}
    >
      <Container>
        <div className="title">{`Add Breakfast Voucher to this Room?`}</div>
        <div className="text">{`Adding this voucher will apply an additional charge of $${voucherPrice} to this booking. `}</div>
        <div className="buttonContainer">
          <Button
            danger
            onClick={() => setIsOpen(false)}
            additionalstyle={`
              width: 79px;
              margin-right: 16px;
            `}
          >
            Cancel
          </Button>
          <Button
            success
            onClick={handleAddVoucher}
            data-loading={addVoucherLoading}
            additionalstyle={`
              width: 73px;
            `}
          >
            {addVoucherLoading ? null : "Apply"}
          </Button>
        </div>
      </Container>
    </MainModal>
  );
}

export default ModalGeneralFailed;
